//export const host = 'http://localhost:8090/'
export const host = 'https://ecfinder.cc/'
export const timeZone = 'Asia/Colombo'      
export const websocket_host = 'https://ecfinder-7e8df.uc.r.appspot.com/ws'

